function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("path", {
  d: "M13.5 5.656l3.335 4.17c.276.344.22.848-.125 1.124-.142.113-.318.175-.5.175H9.54c-.442 0-.8-.358-.8-.8 0-.182.061-.358.175-.5l3.335-4.17c.276-.344.78-.4 1.125-.124.046.037.088.079.125.125z",
  transform: "translate(-323 -6674) translate(16 6499) translate(20 160) translate(287 15) rotate(90 12.875 8)"
}), React.createElement("path", {
  d: "M0 8.069V7.93C0 7.417.418 7 .934 7H11v2H.934C.418 9 0 8.583 0 8.069z",
  transform: "translate(-323 -6674) translate(16 6499) translate(20 160) translate(287 15)"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/filled-arrow-right.adf47913.svg";
export { SvgComponent as ReactComponent };